import RemoveUserModal from './RemoveUserModal'

export default RemoveUserModal
